import type { MultiLocationSelectorFieldProps } from '@frontend/multi-location-selector';
import { useAppScopeStore } from '@frontend/scope';
import { useFormField } from '@frontend/design-system';

export const useLocationIdsField = (initialSelectedLocationIds: string[]) => {
  const { selectedOrgId: orgId } = useAppScopeStore();
  const fieldProps = useFormField(
    {
      type: 'multiselect',
      value: initialSelectedLocationIds,
    },
    [initialSelectedLocationIds, orgId]
  );

  const locationsFieldProps: MultiLocationSelectorFieldProps = {
    locationIds: { ...fieldProps, name: 'locationIds' },
  };

  return { locationsFieldProps, selectedLocationIds: fieldProps.value };
};
